import { Button } from "@onegovbugs/onegov-react-components";
import React from "react";
import styles from "../pages/dashboard/Dashboard.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

const renderButton = (finished, step, goTo, items, onlyGoMain, history, form, buttonDisabled) => {
 
  if (finished || onlyGoMain) {
    return (
      <Button
        disabled={buttonDisabled}
        secondary
        onClick={() => {
          if (!buttonDisabled) {
            history.push(goTo);
          }
        }}
      >
        Edit
      </Button>
    );
  }
  if (!step) {
    return (
      <Button
        disabled={buttonDisabled}
        onClick={() => {
          if (!buttonDisabled) {
            history.push(goTo);
          }
        }}
      >
        Start
      </Button>
    );
  }
  if (!isNaN(step)) {
    return (
      <Button
        disabled={buttonDisabled}
        onClick={() => {
          if (!buttonDisabled) {
            const lastItem = items.find((i) => i.index === step);
            let url = lastItem && lastItem.url ? lastItem.url : goTo;
            url = !url.includes("{{form}}")
              ? url
              : url.replace("{{form}}", form);
            history.push(url);
          }
        }}
      >
        Continue
      </Button>
    );
  }
};

const renderStatus = (finished, step) => {
  if (finished)
    return <span className={`${styles.statusCompleted}`}>Completed</span>;
  if (!step)
    return <span className={`${styles.status}`}>Not started</span>;
  if (!isNaN(step))
    return <span className={`${styles.statusInProgress}`}>Incomplete</span>;
};

const renderSection = (
  title,
  description,
  goTo,
  finished,
  step,
  items,
  onlyGoMain,
  history,
  form,
  buttonDisabled
) => {
  if (!history) {
    throw new Error('Missing history parameter in renderSection.')
  }
  return (
    <div key={`${title}-${description}`} className={styles.section}>
      {renderStatus(finished, step)}
      <h3>{title}</h3>
      <div className={"row"}>
        <div className={"col-9"}>{description}</div>
        <div className={`col-3 ${styles.buttonSection}`}>
          {renderButton(finished, step, goTo, items, onlyGoMain, history, form, buttonDisabled)}
        </div>
      </div>
    </div>
  );
};

const renderChange = (fieldname, touches) => touches[fieldname] ? <>
  &nbsp;
  <FontAwesomeIcon
    icon={faExclamationCircle}
    className={styles.faIconChange}
  />
</> : null;

export {
  renderSection, renderChange
};
